import { ChangeEvent, useState } from "react";

interface FormattedNumberInputProps {
  value: number | null;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  style?: React.CSSProperties;
  name?: string;
  disabled?: boolean;
}

export default function FormattedNumberInput({ value, onChange, name, disabled, ...props }: FormattedNumberInputProps) {
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    // Remove all non-digit characters except comma, dot, and minus sign
    const newValue = e.target.value.replace(/[^\d,.]/g, "");
    const { name } = e.target;
    // When input is empty, pass empty string
    onChange({
      ...e,
      target: {
        ...e.target,
        value: newValue,
        name,
      },
    });
  };

  const displayValue = value === null ? "" : isFocused ? value : value.toLocaleString("ru-RU");

  return (
    <input
      type={isFocused ? "number" : "text"}
      {...props}
      disabled={disabled}
      value={displayValue}
      onFocus={(e) => {
        setIsFocused(true);
        // Move cursor to end
        const val = e.target.value;
        e.target.value = "";
        e.target.value = val;
      }}
      onBlur={() => setIsFocused(false)}
      onChange={handleChange}
      style={{
        ...props.style,
        textAlign: "right",
        color: disabled ? "#666" : "inherit",
      }}
      name={name}
    />
  );
}
